'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../css/Octicon.css');

var Octicon = _react2['default'].createClass({
  displayName: 'Octicon',

  propTypes: {
    name: _react.PropTypes.string.isRequired,
    className: _react.PropTypes.string,
    mega: _react.PropTypes.bool,
    spin: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      mega: false,
      spin: false
    };
  },
  render: function render() {
    var _props = this.props;
    var name = _props.name;
    var className = _props.className;
    var mega = _props.mega;
    var spin = _props.spin;

    var props = _objectWithoutProperties(_props, ['name', 'className', 'mega', 'spin']);

    var classNames = [mega ? 'mega-octicon' : 'octicon', 'octicon-' + name];
    if (spin) {
      classNames.push('spin-octicon');
    }
    if (className) {
      classNames.push(className);
    }
    return _react2['default'].createElement('span', _extends({}, props, { className: classNames.join(' ') }));
  }
});

exports['default'] = Octicon;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-octicon/lib/Octicon.js
 ** module id = 283
 ** module chunks = 0
 **/